<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const newsListResponse = await useFetch('/api/clothes/newslist')
const topicsList = newsListResponse?.data.value || []
</script>

<template>
  <section class="clothesTopics">
    <SectionTitle title="服装に関するニュース一覧" />
    <div class="block">
      <ul class="list">
        <li
          v-for="item in topicsList"
          :key="item.title"
          class="item"
        >
          <NuxtLink
            :to="'https://weathernews.jp' + item.link"
            class="link"
          >
            <figure>
              <img
                :src="item.image"
                height="70"
                alt=""
                loading="lazy"
              >
            </figure>
            <span>{{ item.title }}
              <span class="date">{{ item.date }}</span>
            </span>
          </NuxtLink>
        </li>
      </ul>
    </div>
  </section>
</template>

  <style lang="scss" scoped>
  .clothesTopics {
    display: flex;
    flex-direction: column;
    gap: 20px;
    .block {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    .list {
      display: flex;
      flex-direction: column;
    }
    .link {
      position: relative;
      display: flex;
      align-items: center;
      gap: 10px;
      padding-block: 10px;
      padding-right: 15px;
      border-bottom: 1px solid #e5e5e5;
      &:before {
        position: absolute;
        top: 50%;
        right: 0;
        width: 8px;
        height: 12px;
        margin-top: -6px;
        background-color: #3569C0;
        clip-path: polygon(0 0, 100% 50%, 0 100%);
        content: '';
      }
      figure {
        height: 70px;
        img {
          width: auto;
          height: 100%;
        }
      }
      span {
        color: #000;
        font-size: 15px;
        line-height: 1.5em;
      }
      .date {
        display: block;
        font-size: 12px;
      }
    }
    .more {
      color: #666;
      font-weight: bold;
      margin-inline: auto;
      text-align: center;
      border: 2px solid #3569C0;
      border-radius: 100vmax;
      min-width: 280px;
      font-size: 15px;
      line-height: 1.5em;
    }
    @media (any-hover: hover) {
      .link {
        cursor: pointer;
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
      .more {
        cursor: pointer;
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
    }
  }
  .main {
    .clothesTopics {
      @media (min-width: 830px) {
      }
    }
  }
  </style>
